module.exports = {
  encodeParam: function(params) {
    var ret = [];
    for (var k in params) {
      if (params[k]) {
        ret.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
      }
    }
    return ret.join('&');
  },
  css2Text: function(params) {
    var ret = [];
    for (var k in params) {
      if (Array.isArray(params[k])) {
        for (var a of params[k]) {
          ret.push(k+':'+a);
        }
      } else {
        ret.push(k+':'+params[k]);
      }
    }
    return ret.join(';');
  }
}
